import { gql } from '@apollo/client';
import { FieldFragment } from 'graphql/Field/fragments/FieldFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
import { SaleItemFileFragment } from 'graphql/SaleItemFile/fragments/SaleItemFileFragment';
import { SaleItemGroupFragment } from 'graphql/SaleItemGroup/fragments/SaleItemGroupFragment';
import { SaleItemImageFragment } from 'graphql/SaleItemImage/fragments/SaleItemImageFragment';
import { TaxFragment } from 'graphql/Tax/fragments/TaxFragment';
/**
 * @fragment SaleItemFragment
 * @since 1.0.0
 */
export const SaleItemFragment = gql `
  fragment SaleItemFragment on SaleItem {
    id
    sku
    price
    cost
    inventory
    category
    configuration
    optionConfiguration
    active
    promoted
    taxable
    unitOfMeasurement
    title
    summary
    infos
    createdAt
    updatedAt

    taxes {
      ...TaxFragment
    }

    relations {
      id
      type
      quantity
      saleItemId
      relatedSaleItemId
      saleItem {
        id
        title
        price
        sku
      }
      relatedSaleItem {
        id
        title
        price
        sku
      }
    }

    group {
      ...SaleItemGroupFragment
    }

    groups {
      ...SaleItemGroupFragment
    }

    image {
      ...SaleItemImageFragment
    }

    images {
      ...SaleItemImageFragment
    }

    files {
      ...SaleItemFileFragment
    }

    translations {
      id
      title
      summary
      infos
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }

    variants {
      id
      sku
      price
      inventory
      active

      image {
        ...MediaFragment
      }

      options {
        id
        price
        quantity
        item {
          id
          sku
          title
          infos
          price
          active
          deletedAt
          relations {
            id
            type
            quantity
            relatedSaleItem {
              id
              title
              price
              sku
            }
          }
          group {
            id
            title
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          groups {
            id
            title
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }

          image {
            ...SaleItemImageFragment
          }
        }
        included
        locked
        proposed
        recommended
      }

      values {
        id
        value
        field {
          ...FieldFragment
        }
      }

      fieldValues {
        id
        value
        field {
          ...FieldFragment
        }
      }
    }

    options {
      id
      price
      quantity
      required
      included
      locked
      proposed
      recommended
      relations {
        id
        type
        quantity
        saleItem {
          id
          title
          infos
          sku
          price
          taxable
          category
          configuration
          optionConfiguration
          group {
            id
            title
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          groups {
            id
            title
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          active
          promoted
        }
        relatedSaleItem {
          id
          title
          infos
          sku
          price
          taxable
          category
          configuration
          optionConfiguration
          group {
            id
            title
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          groups {
            id
            title
            display
            hasUniqueOptionRestriction
            mustHaveOptionSelected
          }
          active
          promoted
        }
      }
      item {
        id
        title
        infos
        sku
        price
        taxable
        inventory
        category
        configuration
        optionConfiguration
        group {
          id
          title
          display
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }
        groups {
          id
          title
          display
          hasUniqueOptionRestriction
          mustHaveOptionSelected
        }
        active
        promoted
        relations {
          id
          type
          quantity
          relatedSaleItem {
            id
            title
            price
            sku
            active
          }
        }

        image {
          ...SaleItemImageFragment
        }
      }
    }

    fieldValues {
      value
      field {
        id
        name
        title
        infos
        visibility
        promote
        group {
          id
          category
        }
      }
    }

    packages {
      id
      included
      locked
      proposed

      package {
        id
        sku
        title
        infos
        price
        active
        icon
      }
    }
  }

  ${SaleItemGroupFragment}
  ${LanguageFragment}
  ${SaleItemImageFragment}
  ${SaleItemFileFragment}
  ${FieldFragment}
  ${MediaFragment}
  ${TaxFragment}
`;
